import Style from './style'

import Pagenation from 'widget/Pagenation'

import useGetStoreManagerStoreTicketRecord from 'entity/store/useGetStoreManagerStoreTicketRecord'

import TStyle from 'shared/style/tableStyle'
import timestampCalculator from 'shared/lib/timestampCalculator'
import {convertRecordTypeAsName} from 'shared/constant/lookup/recordType'
import Search from 'widget/Search'
import TableLoading from 'shared/ui/TableLoading'
import SortableHeader from 'shared/ui/SortableHeader'

const StoreTicketRecord = () => {
	const [ticketRecord, isLoading] = useGetStoreManagerStoreTicketRecord()

	const recordSizeList = [
		'short',
		'medium',
		'expand',
		'expand',
		'expand',
		'long',
		'expand',
		'long',
		'medium',
		'long',
	]
	const recordTableHeadList = [
		{label: 'IDX', sortKey: 'idx'},
		{label: '사용자 IDX', sortKey: 'account_idx'},
		{label: '이름', sortKey: 'account_name'},
		{label: '닉네임', sortKey: 'account_nickname'},
		{label: '연락처', sortKey: 'account_contact'},
		{label: '매장 이용권 유형', sortKey: 'ticket_name'},
		{label: '사용처', sortKey: 'event_name'},
		{label: '분류', sortKey: 'ticket_record_type_flag'},
		{label: '번호', sortKey: 'number'},
		{label: '기록 날짜', sortKey: 'created_at'},
	]

	return (
		<Style.Wrapper>
			<Style.Area $expand>
				<h2>스토어 매장 이용권 사용 내역</h2>
				<Search
					placeholder='IDX, 이름 및 닉네임으로 검색 가능'
					voucherTypeFilter={true}
				/>

				<TableLoading isLoading={isLoading}>
					<TStyle.TableDiv>
						<TStyle.TableRow $title>
							{recordTableHeadList.map((elem, index) => (
								<TStyle.Data key={index} $title $size={recordSizeList[index]}>
									<SortableHeader sortKey={elem.sortKey}>
										{elem.label}
									</SortableHeader>
								</TStyle.Data>
							))}
						</TStyle.TableRow>
						{ticketRecord?.data?.store_ticket_record?.map((elem, index) => (
							<TStyle.TableRow key={index} $odd={index % 2 === 1}>
								<TStyle.Data $size={recordSizeList[0]}>{elem?.idx}</TStyle.Data>
								<TStyle.Data $size={recordSizeList[1]}>
									{elem?.account_idx}
								</TStyle.Data>
								<TStyle.Data $size={recordSizeList[2]}>
									{elem?.account_name}
								</TStyle.Data>
								<TStyle.Data $size={recordSizeList[3]}>
									{elem?.account_nickname}
								</TStyle.Data>
								<TStyle.Data $size={recordSizeList[4]}>
									{elem?.account_contact || '-'}
								</TStyle.Data>
								<TStyle.Data $size={recordSizeList[5]}>
									{elem?.ticket_name || '-'}
								</TStyle.Data>
								<TStyle.Data $size={recordSizeList[6]}>
									{elem?.event_name || '-'}
								</TStyle.Data>
								<TStyle.Data $size={recordSizeList[7]}>
									{convertRecordTypeAsName[elem?.ticket_record_type_flag]}
								</TStyle.Data>
								<TStyle.Data $size={recordSizeList[8]}>
									{elem?.number}
								</TStyle.Data>
								<TStyle.Data $size={recordSizeList[9]}>
									{timestampCalculator(elem?.created_at)}
								</TStyle.Data>
							</TStyle.TableRow>
						))}
					</TStyle.TableDiv>
				</TableLoading>

				<Pagenation maxPage={ticketRecord?.data?.max_page} />
			</Style.Area>
		</Style.Wrapper>
	)
}

export default StoreTicketRecord
